import React from 'react';
import PropTypes from 'prop-types';

import { ResultsSummaryType } from 'engagementReport/enums/propTypes';
import classNames from 'classnames';
import { useIsFiltered } from '../hooks';

function ResultsSummaryFooter(props) {
  const { resultsSummary, multiPagesDisplay } = props;
  const { filterOptions } = resultsSummary;
  const filtered = useIsFiltered(filterOptions);
  const hasDeduplication = filterOptions.deduplicate === '1';

  if (!filtered) return null;

  return (
    <div
      className={classNames('results-summary-footer', {
        'no-border': multiPagesDisplay,
      })}
    >
      * Note: Results contained in this report represent a subset of submissions.{' '}
      {hasDeduplication ? 'Duplicate submissions have been excluded.' : ''}
    </div>
  );
}

ResultsSummaryFooter.propTypes = {
  resultsSummary: ResultsSummaryType.isRequired,
  multiPagesDisplay: PropTypes.bool,
};

ResultsSummaryFooter.defaultProps = {
  multiPagesDisplay: false,
};

export default ResultsSummaryFooter;
